import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import type ComposeStyles from './ComposeStyles';
import generateCssVariablesForCompose from 'owa-color-utils/lib/composeCssColors/generateCssVariablesForCompose';
import generateDefaultButtonStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateDefaultButtonStyles';
import generateLinkStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateLinkStyle';
import { getButtonStyle } from 'owa-recurrence-utils/lib/recurrenceSummaryUtils';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPaletteAsRawColors } from 'owa-theme';
import type { IButtonStyles } from '@fluentui/react/lib/Button';

/**
 * This function support the compose styles according the cal-css-variables feature flag
 * When the flag is enable the CSS colors will be overwritten. when the flag is disabled the styles will be generated.
 */
export default function getComposeStyles(
    shouldUseCssVariablesStyle: boolean,
    colorScheme: ColorScheme,
    cssVariablesStyle: string,
    textInputCssVariablesStyle: string
): ComposeStyles {
    let textFieldStyle;
    let linkGetStyles;
    let quickComposeStyle = generateCssVariablesForCompose(colorScheme);
    let composeActionButtonColors: ColorScheme;
    let cssVariabelsStyle: string = cssVariablesStyle;
    let editTitleTextStyle: string = textInputCssVariablesStyle;
    let recurrenceSummaryButton: IButtonStyles = getButtonStyle();
    let discardButtonStyle: IButtonStyles;
    let footerStyle;

    // when the CSS variables feature flag is disabled, populate all the styles to inject
    if (shouldUseCssVariablesStyle) {
        let textColor = getOptimalTextColorString(
            getPaletteAsRawColors().white,
            colorScheme,
            colorScheme.calPrimary
        );
        discardButtonStyle = generateDefaultButtonStyle(colorScheme);
        footerStyle = { backgroundColor: colorScheme.calLighterAlt };
        quickComposeStyle = null;
        textFieldStyle = { color: textColor };
        composeActionButtonColors = colorScheme;
        linkGetStyles = generateLinkStyle(colorScheme, getPaletteAsRawColors().neutralLighterAlt);
        cssVariabelsStyle = null;
        editTitleTextStyle = null;
        recurrenceSummaryButton = null;
    }

    return {
        textFieldStyle: textFieldStyle,
        linkGetStyles: linkGetStyles,
        quickComposeStyle: quickComposeStyle,
        composeActionButtonColors: composeActionButtonColors,
        cssVariabelsStyle: cssVariabelsStyle,
        editTitleTextStyle: editTitleTextStyle,
        recurrenceSummaryButton: recurrenceSummaryButton,
        discardButtonStyle,
        footerStyle,
    };
}
